import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { useModalData } from '../../../components/modals/ModalsContext'
import { useSaveWidget } from './_requests/saveScreen'
import { useScreenItem } from './_load/ScreenItemLoader'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import Line from '../../../packages/kiti/components/helpers/Line'
import Preview from './Preview'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const EditWidgetForm = () => {
  const { initialState } = useModalData() || {}
  const screenItem = useScreenItem()
  const [onSubmit, { loading, error }] = useSaveWidget()

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={screenItem || initialState}>
      <Grid gap={1} align="stretch">
        <Col flex={5}>
          <Preview />
        </Col>
        <Col>
          <Line vertical height="100%" />
        </Col>
        <Col flex={2}>
          <GeneralSection />
          <SubmitBar loading={loading} error={error} />
        </Col>
      </Grid>
    </Form>
  )
}

export default EditWidgetForm
